import React from 'react';
import './HomeSection.css';

const HomeSection = ({ id }) => {
  return (
    <section id={id} className="video-section">
      <video autoPlay muted loop playsInline className="video-background">
        <source src="/videos/giesen.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="video-content">
        <div className="center-content">
          <img
            src="/images/logo.png"
            alt="Logo"
            className="logo"
          />
        </div>

        <div className="bottom-content">
          <h1>GÄRTNER IN LINDAU - GROßRAUM</h1>

          <div className="scroll-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeSection;